"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.search.placeholder': '搜索入职会话...',
};
